import { Event } from '@ftr/bus-messages';
export class LiveSttErrorOccurred extends Event {
    constructor() {
        super(...arguments);
        this.$name = LiveSttErrorOccurred.NAME;
        this.$version = 0;
    }
}
LiveSttErrorOccurred.NAME = 'ftr-regional-api/LiveSttErrorOccurred';
